<oaibox-stats-card title="Tracking Details Configuration" icon="fa-solid fa-truck-fast" gradient="success">
  <form class="form p-g" [formGroup]="trackingDetailsConfigurationForm" (ngSubmit)="saveConfiguration()">
    <div class="d-flex flex-wrap g-g">
      <div class="flex-fill errors-wrapper">
        <label for="expeditionDate" class="form-label">Expedition Date</label>
        <input id="expeditionDate" type="date" class="form-control"
               [formControl]="trackingDetailsConfigurationForm.controls.expeditionDate"
               [class.invalid-input]="trackingDetailsConfigurationForm.controls.expeditionDate.errors">
        @if (trackingDetailsConfigurationForm.controls.expeditionDate.errors?.['required']) {
          <div class="input-error">
            Expedition Date is required
          </div>
        }
      </div>

      <div class="flex-fill errors-wrapper">
        <label for="waybill" class="form-label">Waybill</label>
        <input id="waybill" type="text" class="form-control"
               [formControl]="trackingDetailsConfigurationForm.controls.waybill"
               [class.invalid-input]="trackingDetailsConfigurationForm.controls.waybill.errors">
        @if (trackingDetailsConfigurationForm.controls.waybill.errors?.['required']) {
          <div class="input-error">
            Waybill is required
          </div>
        }
      </div>
    </div>

    <div class="errors-wrapper">
      <label for="trackingUrl" class="form-label">Tracking URL</label>
      <input id="trackingUrl" type="text" class="form-control"
             [formControl]="trackingDetailsConfigurationForm.controls.trackingUrl"
             [class.invalid-input]="trackingDetailsConfigurationForm.controls.trackingUrl.errors">
      @if (trackingDetailsConfigurationForm.controls.trackingUrl.errors?.['required']) {
        <div class="input-error">
          Tracking URL is required
        </div>
      }
    </div>

    <div class="buttons-wrapper">
      <button type="button" class="btn btn-ignore" (click)="closeModal()">
        Cancel
      </button>
      <button type="submit" class="btn btn-success" [disabled]="trackingDetailsConfigurationForm.invalid">
        Save
      </button>
    </div>
  </form>
</oaibox-stats-card>
